import { NgModule } from '@angular/core';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { CustomToastComponent } from './components';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [TranslateModule, NzNotificationModule],
  declarations: [CustomToastComponent],
  exports: [CustomToastComponent],
  providers: [],
})
export class CustomToastModule {}
